import React from "react";

function RelatedFamily ({ clientInfo }) {

    return(
        <div>
            <strong>
                {"בני משפחה: "}
            </strong>
            {clientInfo['relatedFamily'] && clientInfo['relatedFamily'].length > 0 ?
                <a
                    target="_blank"
                    style={{ textDecoration: 'underline', color: 'black' }}
                    href={`/clients?page=1&parent_id=${clientInfo['id']}`}
                >
                    {`הצג (${clientInfo['relatedFamily'].length}) בני משפחה`}
                </a> :
                '-'
            }
        </div>
    )
}

export default RelatedFamily